var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 58,
    viewBox: "0 0 269 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269 1a1 1 0 00-2 0h2zM0 57a1 1 0 102 0H0zM267 1v4h2V1h-2zm-23 27H25v2h219v-2zM0 53v4h2v-4H0zm25-25C11.193 28 0 39.193 0 53h2c0-12.703 10.297-23 23-23v-2zM267 5c0 12.703-10.297 23-23 23v2c13.807 0 25-11.193 25-25h-2z",
    fill: "#BFBFBF"
  })));
}

export default __webpack_public_path__ + "./fonts/yes.c636f820ee2891dd060849a50c6a52c6.svg";
export { SvgYes as ReactComponent };